import { Component, ChangeDetectorRef, OnInit, ViewChild, Output, EventEmitter, Input, SimpleChanges } from '@angular/core';

import { MatDialog, MatSnackBar, MatSidenav } from '@angular/material';
import { from, Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { FolderService } from '../../services/folder.service';
import * as  JSZip from 'jszip';
import * as JSZipUtil from 'jszip-utils'
import { saveAs } from "file-saver";
import * as _ from 'lodash';
import { ShareFileModalComponent } from '../share-file-modal/share-file-modal.component';
import { ContextMenuComponent } from "ngx-contextmenu";
import { FilterService } from '../../services/filter.service'
import { CreateFolderModalComponent } from '../create-folder-modal/create-folder-modal.component';
import { NewFileModalComponent } from '../../files/new-file-modal/new-file-modal.component';
// import { $ } from 'protractor';
declare var $: any;
// import { NewFileModalComponent } from '../../files/new-file-modal/new-file-modal.component'
import { SharedService } from 'src/app/shared.service';
import { CdkDragDrop } from '@angular/cdk/drag-drop';
import { async } from '@angular/core/testing';
import { resolve } from 'url';
import { ClientService } from 'src/app/services/client.service';
import { StaffService } from 'src/app/services/staff/staff.service';
import { UtilityService } from '../../services/utility.service'
import { reject } from 'q';
import { AssetService } from 'src/app/services/asset.service';
import { FileService } from 'src/app/services/file.service';
JSZip.support.nodebuffer = false;






@Component({
  selector: 'app-single-folder',
  templateUrl: './single-folder.component.html',
  styleUrls: ['./single-folder.component.scss']
})

export class SingleFolderComponent implements OnInit {

  @ViewChild(ContextMenuComponent, { static: false }) public basicMenu: ContextMenuComponent;
  @ViewChild('sidenav', { static: false }) public mydsidenav: MatSidenav;
  @Output() titleChanged: EventEmitter<any> = new EventEmitter<any>();
  @Output() openFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Output() closeFilesSideNav: EventEmitter<any> = new EventEmitter<any>();
  @Input('documentFolderId') jobFolderId
  @Input('labourjobId') jobId
  @Input('moduleRef') refModuleName
  keepSideNavOpen = true;
  closeBtnNeeded = false;
  filesToDisplay: any;
  allFolders = [];
  preventSingleClick: boolean;
  mainFolderId: any
  subFolders: any = [];
  details: any;
  display: boolean;
  navArray: any;
  fileTitle: any;
  fileId: any;
  type: any;
  updatedFolder: any;
  percentage;
  allFoldersCopy;
  subFoldersCopy;
  cardIndex: any;
  removeFolderBorder: boolean;
  previousIndex: any;
  preciousFolderIndex: any;
  hideCreatebtn: boolean = false;
  userId
  flage
  downloadProgress = 0;
  showProgressbar: boolean = false;
  destFolderName: any;
  afterFilter: any;
  hideNoFolderParent: boolean = false;
  afterFilterFolder: any;
  downloadDisable: boolean = false;
  sharedFiles: boolean = false;
  sharedFileArray;
  isMyDocs: boolean = true;
  allMyDocFolders;
  currentFolder;
  currentProgress;
  showCurrentProgress: boolean = false;
  downloadAllParentFolderProgress: boolean = false;
  // userId
  // flage
  mainDisabled: boolean = false;
  displayCheckBoxes: boolean = false;

  breadCrumbData: any;
  noFilesMessage = {
    title: "No Files!",
    data: "You have not yet uploaded any files"
  }

  noSubFolderMsg = {
    title: "No Folders!",
    data: "You have not yet created any folders"
  }

  filterActive: boolean;
  newFolderIndex: any;
  selectedFoldersArray = [];
  selectedFilesArray = [];
  clients: any;
  instructors: any;
  loader: boolean;
  user: any;
  breadCrumbArray = ['done0', 'files', 'folders'];
  labourDocumentId
  refModule
  constructor(private cd: ChangeDetectorRef, private router: Router, public _folderService: FolderService, private activatedRoute: ActivatedRoute,
    public dialog: MatDialog, public _snackBar: MatSnackBar, public _filterService: FilterService, private _sharedService: SharedService,
    public _assetService: AssetService,
    public _clientService: ClientService, public _staffService: StaffService, public _utilityService: UtilityService) {
    this.router.routeReuseStrategy.shouldReuseRoute = function () {
      return false;
    };


    this._folderService.deleteFolderFiles().subscribe((res) => {
      console.log("RESPONE OF REMOVED FILE", res);
      let index = this.filesToDisplay.findIndex((x) => x._id == res.fileId)
      if (index > -1) {
        // this.filesToDisplay.splice({ _id: res.fileId }, 1)
        this.filesToDisplay.splice(index, 1)
      }
      // this.fileList.splice({ _id: res.fileId }, 1)
      console.log("THIS IS THE FILE LIST AFTER REMOVED", this.filesToDisplay, this.fileList);
      // this.cd.detectChanges()

    })

    this._sharedService.filemarkObservable().subscribe((res) => {
      console.log("FILE MARK AS READ DONE", res);
      if (res.type == 'folder') {
        this.allFolders = this.allFolders.filter((x) => {
          if (res.list.includes(x._id)) {
            x.status.isRead = true
          }
        })
      } else {
        this.filesToDisplay = this.filesToDisplay.filter((x) => {
          if (res.list.includes(x._id)) {
            x.status.isRead = true
            return x
          } else return x
        })
        console.log("THIS IS THE FILE DISPLAY LIST", this.filesToDisplay, this.activeFile, this.selectedFileIndex);
      }
      // this.getSharedFolders()
    })

  }
  folderId;
  fileList;
  folder;
  loading;
  loadingMaterials;
  searchText;
  timer: any;
  delay: Number;
  currentUser;
  hideDownload = false;
  hideUploadbtn = false;
  activeFile = true;
  uploadFileBtn: boolean;
  selectedIndex
  selectedFileIndex
  isView = true
  ngOnInit() {
    // console.log("hello.............................")
    if (this.router.url == '/mydocuments/list') {
      this.uploadFileBtn = false
    }
    else {
      this.uploadFileBtn = true
    }
    console.log("current URL ", this.router.url);
    this.loader = true
    // || this.router.url.includes('labour-job')
    if (this.router.url.includes('/single-folder')) {
      console.log("Inside  folder");
      this.isMyDocs = false;
    } else {
      console.log("In my folder only")
      this.isMyDocs = true;
    }

    if (this.router.url.includes('labour-job') || this.router.url.includes('client/view')) this.isView = false
    else this.isView = true

    this.currentUser = JSON.parse(localStorage.currentUser);
    this.user = JSON.parse(localStorage.getItem('userRoles'))

    if (this.user.isAdmin || this.user.isManager) {
      this.noSubFolderMsg = {
        title: "No Folders!",
        data: "You have not yet created any folders"
      }

      this.noFilesMessage = {
        title: "No Files!",
        data: "You have not yet uploaded any files"
      }
    } else {
      this.noSubFolderMsg = {
        title: "No Folders!",
        data: "You do not yet have any shared folders"
      }
      this.noFilesMessage = {
        title: "No Files!",
        data: "You do not yet have any shared files"
      }
    }
    this.activatedRoute.params.subscribe(params => {
      console.log("this is for download file or folder", params, this.folderId);
      if (params['folderId']) {
        this.folderId = params['id'];
        this.folderId = params.folderId
        this.userId = params.userId
        this.fileId = params.fileId
        this.markAsReadFile()

      } else if (!this.router.url.includes('labour-job')) {
        if (params['id']) {
          console.log("params['id'] found", params['id'], this.currentUser)
          this.folderId = params.id
          this.userId = this.currentUser._id
          this.activatedRoute.queryParams.subscribe((queryParams) => {
            console.log("what is the queryParams ", queryParams);
            if (queryParams && queryParams.user) {
              this.markAsReadFolder(queryParams.user).then((autoMark) => {
                console.log("folder auto mark done", autoMark);
                this.getFolderFiles('Test1')
              }).catch((err) => {
                console.log("error while folder auto read", err);

              })
            } else {
              let currentUrl = this.router.url.includes('labour-job') || this.router.url.includes('client/view')
              console.log("CALL THIS ELSE FOLDER", currentUrl);
              if (!currentUrl) this.getFolderFiles('Test2')
            }
          })
        }
        else {
          if (this.user.isAdmin || this.user.isManager) {
            // this.hideDownload = true
            this.hideUploadbtn = true
            // this.hideCreatebtn = false
            this.getFolders();
          }
          else {
            this.getSharedFolders();
            this.getSharedFiles();
          }
        }
      }
    });


    if (this.user.isTrainer) { this.hideUploadbtn = true; this.hideCreatebtn = true }
    else if (this.user.isClient) { this.hideUploadbtn = true; this.hideCreatebtn = true }

    this._sharedService.sharedFolder.subscribe(fold => {
      console.log("in folder", fold)
      if (fold.type == 'file') {
        console.log("folder id from params", this.folderId);
        var index = _.findIndex(this.fileList, function (o) {
          console.log("files are", o._id, "recievedId", fold.fileId);
          return o._id == fold.fileId
        })
        if (index > -1) {
          console.log("file found at", index);
          this.fileList.splice(index, 1)
          if (this.subFolders.length > 0) {
            this.openFileDetails(this.subFolders[0], 'folder', 'test1')
            $("#folder_card_0").addClass('selectedBorder')
          }
          else if (this.fileList.length > 0) {
            this.openFileDetails(this.fileList[0], 'folder', 'test2')
          }
          else {
            this.closeFilesSideNav.emit("close")
          }
          this.filesToDisplay = JSON.parse(JSON.stringify(this.fileList))
        }

      }
      else {
        var index = _.findIndex(this.subFolders, function (o) { return o._id == fold.fileId })
        console.log("index", index);
        if (index > -1) {
          console.log("index in if", index);
          this.subFolders.splice(index, 1)
          if (this.subFolders && this.subFolders.length > 0) {
            console.log("index in subFolders if", index);
            this.openFileDetails(this.subFolders[0], 'folder', 'test3')
            $("#folder_card_0").addClass('selectedBorder')
          }
          else if (this.fileList && this.fileList.length > 0) {
            console.log("index in else if", index);
            this.selectedFileIndex = true
            this.openFileDetails(this.fileList[0], 'folder', 'test4')
          }
          else {
            console.log("index in else", index);
            this.closeFilesSideNav.emit("close")
          }
        }
        if (index == -1) {
          this.closeFilesSideNav.emit("close")
        }
      }
      this.subFoldersCopy = JSON.parse(JSON.stringify(this.subFolders))
      console.log("THE SUBFOLDERS ARE", this.subFolders);
    })


    console.log("check file length !!!!", this.subFolders.length, this.user.isAdmin)
  }


  ngOnChanges(changes: SimpleChanges): void {

    if (changes.jobFolderId && changes.jobFolderId.currentValue) {
      this.user = JSON.parse(localStorage.getItem('userRoles'))
      this.folderId = changes.jobFolderId.currentValue
      if (this.user.isAdmin || this.user.isManager) {
        console.log("LINKED JOB FOLDER DETAILS", changes, this.user.isAdmin);
        this.getFolderFiles('Test3')
      }
      else {
        // this.getSharedFolders()
        this.getSharedDocumentsofLabour()
        // this.getSharedFiles()
      }
    }
    if (changes.refModuleName && changes.refModuleName.currentValue) this.refModule = changes.refModuleName.currentValue
    if (changes.jobId && changes.jobId.currentValue) this.labourDocumentId = changes.jobId.currentValue
  }

  labourDocument(event) {
    this.folderId = event
    // this.getFolderFiles('Test4')
    if (this.user.isAdmin || this.user.isManager) this.getFolderFiles('Test4')
    else this.getSharedDocumentsofLabour()
  }

  addFileModal() {
    let obj = {
      folderId: this.folderId,
      document: true
    }
    let currentUrl = this.router.url.includes('labour-job')
    if (currentUrl) {
      obj['labourjob'] = this.labourDocumentId
      obj['isLabour'] = true
    }
    var addedCourse = this.openDialog(NewFileModalComponent, obj).subscribe((courses) => {
      console.log("WHAT IS THE DATA AFTER FILE UPLOAD", courses);

      this.getFolderFiles('Test5');
    }, err => {
      console.log("ERROR", err);

    });
  }


  shareWith(file) {
    console.log("ShareWith", file);
    this.openDialog(ShareFileModalComponent).subscribe(users => {
      console.log('Users', users);
      users.file = file.item;
      console.log("AFTER ADDING ID", users);
      this.openSnackBar("Shared successfully!", "ok")
    })
  }
  createFolder() {
    console.log("WHAT IS THE FOLDER ID", this.folderId, this.refModule);
    let obj = {
      folderId: this.folderId,
      isview: this.isView,
      labourDocumentId: this.labourDocumentId,
      refModule: this.refModule != undefined ? this.refModule : 'documents'
    }

    this.openDialog(CreateFolderModalComponent, obj).subscribe(folder => {
      if (folder == undefined) return
      console.log("FOLDER NAME RECIEVED", folder);
      this.selectedFileIndex = false
      this.subFolders.push(folder);
      this.openFileDetails(folder, 'folder', 'test4')
    })
  }
  showFiles(folderId) {
    console.log("FOLDER", folderId);

    // this.router.navigate(['/single-folder', folderId])
  }
  openFileDetails(event, type, test) {

    if (type == 'file') {
      // console.log("Open files-details"," type == file")
      $('#folder_card_' + this.preciousFolderIndex).removeClass('selectedBorder')
      $('#folder_card_0').removeClass('selectedBorder')
      // $('#folder_card_0').removeClass('selectedBorder')
      // this.removeFolderBorder = true
      this.previousIndex = event.index
    }
    else if (type == 'folder') {
      // console.log("Open files-details", " type == folder")
      this.preciousFolderIndex = event.index
      // console.log("Open files-details", " type == folder", this.preciousFolderIndex)
      $('#' + this.previousIndex).removeClass('cardBorder')
      $('#0').removeClass('cardBorder')
      // $('#' + this.preciousFolderIndex).removeClass('selectedBorder')
    }
    console.log("value of total folders data", this.subFolders);
    console.log("total file length of this folder", this.filesToDisplay, this.fileList);


    if (this.subFolders && this.subFolders.length > 0) {
      this.openFilesSideNav.emit({ event })
      this._assetService.displayFile({ event })
      this.activeFile = false;
    }
    else if (this.fileList && this.fileList.length > 0 || this.sharedFileArray && this.sharedFileArray.length) {
      console.log("Open files-details", event, test, this.fileList)
      this._assetService.displayFile({ event })
      this.openFilesSideNav.emit({ event })
    }
    this.cardIndex = event.index
    console.log("what is the card index to display", this.cardIndex);

    if ($(window).width() < 769) {
      $('#downloadBtn').addClass('col-md-12')
    }
    else if ($(window).width() > 768) {
      $('#downloadBtn').removeClass('col-md-3')
      $('#downloadBtn').addClass('col-md-4')
      $('#btns').removeClass('col-md-9')
      $('#btns').addClass('col-md-8')
    }
  }


  fileDeleted(event) {
    console.log("In singleFolder", event);
    if (event.type == 'folder') {
      var index = _.findIndex(this.subFolders, function (o) {
        console.log("o._id", o, "event.fileId", event.fileId);
        return o._id == event.fileId.toString();
      })
      if (index > -1) this.subFolders.splice(index, 1)
    }
    else if (event.type == 'file') {
      var index = _.findIndex(this.folder.files, function (o) {
        console.log("o._id", o, "event.fileId", event.fileId);
        return o._id == event.fileId.toString();
      })
      if (index > -1) this.folder.files.splice(index, 1)
    }
    this.mydsidenav.close();
  }

  folderTitleChenged(event) {
    console.log("Title changed event in folder", event);
    this.fileTitle = event.alias
    this.updatedFolder = event;
  }


  singleClick(event, singleFolder) {
    console.log("Single Click Event", event);
    this.preventSingleClick = false;
    const delay = 200;
    this.timer = setTimeout(() => {
      if (!this.preventSingleClick) {
        this.details = singleFolder;
        console.log("singleFolder", this.details);
        this.display = true;
      }
    }, delay);
    this.openFileDetails(singleFolder, 'folder', 'test5')
    this.activeFile = false
  }


  filter() {

    console.log('Inside Filter Section');

    this.filterActive = true;


    this.afterFilter = null
    this.cd.detectChanges()
    this.hideNoFolderParent = true
    this.afterFilterFolder = null
    let search = this.searchText
    console.log('this.searchText======>', this.searchText);
    console.log("in filter", this.filesToDisplay)
    if (!this.searchText) {
      this.filterActive = false;
      console.log('this.filterActive = true;', this.filterActive)
      console.log('Inside If==>', this.hideNoFolderParent);
      this.filesToDisplay = this.fileList;
      this.subFolders = this.subFoldersCopy

      this.cd.detectChanges()
      this.hideNoFolderParent = false
      this.afterFilter = null
      this.afterFilterFolder = null
    }
    else {
      console.log("this.subFoldersCopy in filter", this.subFoldersCopy)
      let tempFolders = _.filter(this.subFoldersCopy, function (o) {
        console.log("o.title", o.title);
        return o.title.toLowerCase().includes(search)
      })
      this.subFolders = tempFolders
      if (this.subFolders.length <= 0) {
        // this.afterFilterFolder = "No folders with matched search text found!"
        this.afterFilterFolder = {
          title: "No Folders!",
          data: "Sorry, no folders matched your search"
        }
      }
      if (this.filesToDisplay) {
        let tempFiles = _.filter(this.fileList, function (o) {
          console.log("o.title", o.title);
          return o.title.toLowerCase().includes(search)
        })
        this.filesToDisplay = tempFiles
      }
      if (this.filesToDisplay && this.filesToDisplay.length <= 0 && this.subFolders.length <= 0) {
        this.afterFilterFolder = null
        this.hideNoFolderParent = false
        // this.afterFilter = "No files or folders with matched search text found!"
        this.afterFilter = {
          title: "No Folders or Files!",
          data: "Sorry, no folders or files matched your search"
        }
      }
    }
  }

  // Utility functions
  openSnackBar(message: string, action: string) {
    this._snackBar.open(message, action, {
      duration: 2000,
    });
  }
  openDialog(someComponent, data = {}): Observable<any> {
    console.log("OPENDIALOG", "DATA = ", data);
    const dialogRef = this.dialog.open(someComponent, { width: "1000px", data });
    return dialogRef.afterClosed();
  }
  getRandomColorClass(i) {
    return this._utilityService.getCommonRandomColorClass(i)
  }


  // Drag n Drop

  drop(event: CdkDragDrop<string[]>, title?: string) {
    console.log("FILE DROP EVENT", event, title);
    if (title == 'file') {
      let fileId = this.filesToDisplay[event.currentIndex]
      console.log("current folderid == ", this.folderId, "fileId==", fileId)
    }
    else if (title == 'folder') {
      console.log("FOLDER DROP EVENT", event);

      if (event.previousContainer.id == "files") {
        console.log("A FILE IS DROPPED IN THE FOLDER")
        if (this.newFolderIndex >= 0) {
          console.log("The data after file dropped is", event)
          let obj = {
            fileIndex: event.previousIndex,
            previousFolder: this.folderId,
            newFolderId: this.subFolders[this.newFolderIndex]
          }

          this.fileDropped(obj)
        }
        else {
          this.openSnackBar("Please Drop On a Folder", "OK")
        }
      }
      else {
        console.log("IN ELSE", event.previousIndex)
        if (this.newFolderIndex && this.newFolderIndex == event.previousIndex || event.previousIndex == event.currentIndex) return
        else if (this.newFolderIndex >= 0) {
          var childId = this.subFolders[this.newFolderIndex]
          var folderId = this.subFolders[event.previousIndex];
          console.log("parent", childId);
          console.log("child", folderId);
          let data = {
            folderId: folderId._id,
            childId: childId._id,
            parent: this.folderId
          }
          console.log("New data", data);
          this.subFolders.splice(event.previousIndex, 1)
          console.log("subFolders =====>>>>>", this.subFolders);

          this._folderService.changeFolderParent(data).subscribe(res => {
            console.log("Updated hierarchy", res);
          })
          if (this.folderId) {
            console.log("this.folderId", this.folderId);
            console.log("this.subFolder", this.subFolders);
            var index = _.findIndex(this.subFolders, function (o) { console.log("o._id", o._id); return o._id == folderId._id })
            // tslint:disable-next-line: curly
            if (index > -1) this.subFolders.splice(index, 1)
          }
          this.openFileDetails(this.subFolders[0], 'folder', 'test6')
          this.selectedIndex = true
        }
      }
    }


  }
  fileDropped(event) {
    console.log("The data after file dropped is", event)
    let fileId = this.filesToDisplay[event.fileIndex]._id
    let obj = {
      destinationFolder: event.newFolderId._id,
      sourceFolder: event.previousFolder,
      fileId: fileId
    }

    console.log("Object For API call", obj)

    this._folderService.changeFileParent(obj).subscribe(res => {
      console.log("RESPONSE", res)
      this.filesToDisplay.splice(event.fileIndex, 1)
      if (this.filesToDisplay && this.filesToDisplay.length) {
        this.openFileDetails(this.filesToDisplay[0], 'file', 'test7')
        this.selectedFileIndex = true
      } else {
        this.openFileDetails(this.subFolders[0], 'folder', 'test8')
        this.selectedIndex = true
      }
    }, err => {
      this.openSnackBar("Something Went Wrong!", "Ok");
    })
  }

  sortedFolderName(event) {
    console.log("event in file drag", event)
  }
  getPlaceholder(event) {
    console.log("folderNamefolderName", event)
    this.destFolderName = event
  }

  // Download functions

  downloadAll() {
    console.log('Download all calling', this.folder);
    this._folderService.getFolderWithSubFolder(this.folder._id).subscribe(folders => {
      console.log("LIST OF ALL FOLDERs", folders);

      if (folders.length) {
        this.downloadDisable = true;
        this.showProgressbar = true;
        this.allFolderArray(folders).then((resposne) => {
          console.log('Ater All Folder Complete');
          this.downloadDisable = false;
          this.showProgressbar = false;
          this.cd.detectChanges();
        }).catch((err) => {
          console.log('Error Here', err);
        })
      }
    })
  }

  downloadSharedFiles() {
    console.log('Share File Download Click', this.filesToDisplay);

    let tempFileList = this.filesToDisplay;
    let zip: JSZip = new JSZip();
    let count = 0;
    let download = 0;
    let myZip;
    let percent = 100 / tempFileList.length;

    new JSZip.external.Promise((resolve, reject) => {
      console.log('Download all clicked');
      _.forEach(this.filesToDisplay, (file) => {
        var filename = file.path.split("/")[3];
        JSZipUtil.getBinaryContent(file.path, {
          progress(e) {
            console.log("progress===>", e);
            var percent_complete = (e.loaded / e.total) * 100;
            console.log("progress===>", percent_complete);
          }
        }).then((e) => {
          console.log('Then Event===>', e)
          download = download + percent;
          this.downloadProgress = download;
          console.log(" this.downloadProgress===>", this.downloadProgress);
          zip.file(filename, e, { binary: true });
          count++;
          if (count == tempFileList.length) {
            zip.generateAsync({ type: 'blob' }).then((content) => {
              saveAs(content, 'shredfile');
              this.showProgressbar = false;
              let markedList = []
              this.filesToDisplay.filter((x) => {
                if (x.status.isRead == false) markedList.push(x._id)
              })
              console.log("THIS IS THE MARKED LIST TO BE UPDATE", markedList);
              if (markedList && markedList.length) {
                this._folderService.markAsRead(markedList).subscribe((res) => {
                  this.filesToDisplay = this.filesToDisplay.filter((x) => {
                    if (markedList.includes(x._id)) {
                      x.status.isRead = true
                    }
                    return x
                  })
                  // this.openSnackBar('Files marked as read', 'OK')
                  // this.getSharedFolders()
                })
              }
            });
          }
        })
      });
    }).then((data) => {
      console.log("data in .then", data);
    })
  }


  // ndfHFb-c4YZDc-Bz112c ndfHFb-c4YZDc-DH6Rkf-Bz112c
  downloadAllParentFolder() {

    console.log('Inside DownloadAll Parent Folder==>');
    let data = { folderArray: this.allFolders }
    this._folderService.getallFoldersWithFiles(data).subscribe(res => {
      this.mainDisabled = true;
      this.downloadAllParentFolderProgress = true;
      console.log("RESPONSE", res)
      this.allMyDocFolders = res;
      console.log('Download all calling', this.allMyDocFolders);

      this.allFolderArray(this.allMyDocFolders).then((resposne) => {

        this.mainDisabled = false;
        this.downloadAllParentFolderProgress = false;
        let markedList = []
        this.allFolders.filter((x) => {
          if (x.status.isRead == false) markedList.push(x._id)
        })
        if (markedList && markedList.length) {
          this._folderService.markAsRead(markedList).subscribe((res) => {
            console.log("RES OF MARK AS READ DONE", res);
            this.allFolders = this.allFolders.filter((x) => {
              if (markedList.includes(x._id)) {
                x.status.isRead = true
              }
            })

            // this.getSharedFolders()
            // setTimeout(() => {
            //   this.openSnackBar('Folders marked as read', 'OK')
            // }, 200);
          })
        }

        this.cd.detectChanges();
        console.log('Ater All Folder Complete', this.downloadAllParentFolderProgress);

      }).catch((err) => {
        console.log('Error Here', err);
      })
    }, err => {
      this.openSnackBar("Something Went Wrong!", "Ok");
    })
  }

  allFolderArray(folderArray) {
    console.log('allFolderArray', folderArray);
    let count = 0;
    return new Promise((resolve, reject) => {
      if (folderArray && folderArray.length) {
        folderArray.forEach(async folder => {
          const result = await this.makeZip(folder);
          console.log('Folder Complete==>', folder.title, count);
          count++;
          if (count == folderArray.length) {
            resolve()
          }
        })
      } else {
        resolve()
      }
    })
  }

  makeZip(folder) {
    // this.showCurrentProgress = true;
    // console.log("this.showCurrentProgress===>", this.showCurrentProgress);
    let count = 0;
    let zip: any = new JSZip();
    let fileArray = folder.files;
    let percent = 100 / fileArray.length;
    let download = 0;
    this.currentFolder = folder.title;
    this.cd.detectChanges();

    return new Promise((resolve, reject) => {
      if (folder && folder.files && folder.files.length) {
        fileArray.forEach(async file => {
          const result = await this.downloadOne(file)
          var filename = file.path.split("/")[3];
          download = download + percent;
          this.currentProgress = download;
          console.log("this.downloadProgress===>", this.currentProgress);
          zip.file(filename, result, { binary: true });
          count++;
          if (count == fileArray.length) {
            this.showCurrentProgress = false;
            // console.log("this.showCurrentProgress===>", this.showCurrentProgress);
            zip.generateAsync({ type: 'blob' }).then((content) => {
              saveAs(content, folder.title);
              resolve()
            });
          }
        })
      } else {
        let msg = "No files contais in folder" + folder.title;
        // this.showCurrentProgress = false;
        this.openSnackBar(msg, "ok")
        resolve();
      }
    })
  }


  downloadOne(file) {
    return new Promise((resolve, reject) => {
      JSZipUtil.getBinaryContent(file.path, {
        progress(e) {
          // console.log("progress Event", e);
        }
      }).then((e) => {
        console.log('Download Complete', e);
        resolve(e)
      })
    })
  }

  // APIs

  getFolders() {
    // var that = this;
    this._folderService.getFolders().subscribe((folders) => {
      console.log('Folders:::::::::', folders);
      this.subFolders = folders
      if (this.subFolders && this.subFolders.length > 0) {
        this.openFileDetails(this.subFolders[0], 'folder', 'test9')
        this.activeFile = false
      }
      this.subFoldersCopy = JSON.parse(JSON.stringify(this.subFolders))
      this.allFolders = folders;
      this.allFoldersCopy = this.allFolders
      this.loader = false
    });
  }
  getSharedFolders() {
    this._folderService.getSharedFolders().subscribe((folders) => {
      console.log('Folders while share', folders);
      this.subFolders = folders.sharedFolders;
      this.allFolders = folders.sharedFolders;
      this.sharedFileArray = folders.sharedFiles;
      this.sharedFiles = true
      this.filesToDisplay = folders.sharedFiles
      this.fileList = this.filesToDisplay
      if (this.allFolders && this.allFolders.length > 0) {
        console.log("this.allFolders", this.allFolders)
        this.openFileDetails(this.allFolders[0], 'folder', 'test10')
        this.activeFile = false
      } else if (this.sharedFileArray && this.sharedFileArray.length) {
        console.log("this.sharedFile", this.sharedFileArray)
        this.openFileDetails(this.sharedFileArray[0], 'file', 'test18')
        this.activeFile = true
      }
      // this.subFolders = folders
      // if (this.subFolders && this.subFolders.length > 0) {
      //   this.openFileDetails(this.subFolders[0], 'folder')
      //   this.activeFile = false
      // }
      this.subFoldersCopy = JSON.parse(JSON.stringify(this.subFolders))
      // this.allFolders = folders;
      this.loader = false
    });
  }

  getSharedFiles() {
    var that = this;
    // this._folderService.getSharedFiles().subscribe((files) => {
    //   console.log('files List', files);
    //   this.fileList = files;
    //   if (this.fileList && this.fileList.length > 0) {
    //     this.openFileDetails(this.fileList[0], 'file')
    //     this.sharedFiles = true;
    //     this.sharedFileArray = this.fileList;
    //     console.log('this.sharedFiles===>', this.sharedFiles);
    //     // this.activeFile = true
    //   }
    //   this.filesToDisplay = JSON.parse(JSON.stringify(this.fileList))
    //   this.loader = false
    // });
  }


  // Get Shared documents of operative user for single labour job
  getSharedDocumentsofLabour() {
    this._folderService.getSharedLabourDocumets(this.folderId).subscribe((documents) => {
      console.log("DOCUMENT LIST FOR CLIENT USER", documents);
      this.loader = false
      this.subFolders = documents.sharedFolders;
      this.allFolders = documents.sharedFolders;
      this.breadCrumbData = documents.navigationFolder
      this.sharedFileArray = documents.sharedFiles;
      this.sharedFiles = true
      this.filesToDisplay = documents.sharedFiles
      this.fileList = this.filesToDisplay
      if (this.allFolders && this.allFolders.length > 0) {
        console.log("this.allFolders", this.allFolders)
        this.openFileDetails(this.allFolders[0], 'folder', 'test10')
        this.activeFile = false
      } else if (this.sharedFileArray && this.sharedFileArray.length) {
        console.log("this.sharedFile", this.sharedFileArray)
        this.selectedFileIndex = true
        this.openFileDetails(this.sharedFileArray[0], 'file', 'test18')
        this.activeFile = true
      }
      this.subFoldersCopy = JSON.parse(JSON.stringify(this.subFolders))
    })
  }



  getFolderFiles(test) {
    console.log("THIS IS THE FOLDER ID", this.folderId, test);

    this._folderService.getFolder(this.folderId).subscribe((data) => {
      this.breadCrumbData = data
      console.log('folder:::::::::', data);


      this.folder = data.folders[0];
      this.loader = false
      if (this.folder) {
        this.subFolders = this.folder.child;
        this.subFoldersCopy = JSON.parse(JSON.stringify(this.subFolders))

        this.fileList = data.folders[0].files;
        this.filesToDisplay = this.fileList;
      }
      else {
        this.subFolders = [];
      }

      // console.log('This.SubFolder:::::::::', this.folder.child);

      if (this.folder && this.folder.child && this.folder.child.length == 0 && this.folder.files.length == 0) {
        this.downloadDisable = true;
      } else {
        this.downloadDisable = false;
      }


      // this.subFolders = this.folder.child
      if (data.preFolders != undefined) {
        this.navArray = data.preFolders.reverse();
        console.log("navArray ========>", this.navArray);
        _.map(this.navArray, (obj, index) => {
          index = index + 1
          this.breadCrumbArray.push('done' + index);
        })
      }
      if (this.folder) {
        let no = this.breadCrumbArray.length - 2
        this.breadCrumbArray.push('done' + no);
      }
      /*        this.breadCrumbArray = _.uniqBy(this.breadCrumbArray, function(o){
                return o._id;
              });*/
      console.log("bread ================?", this.breadCrumbArray);

      if (this.subFolders && this.subFolders.length > 0) {
        this.openFileDetails(this.subFolders[0], 'folder', 'test11')
        this.activeFile = false
      }
      else if (this.fileList && this.fileList.length > 0) {
        this.selectedFileIndex = true
        this.openFileDetails({ file: this.fileList[0], index: 0 }, 'file', 'test12')
        // this.activeFile = true
      }
      // console.log("this.folder.child", this.folder.child.reverse());
      // console.log("this.subFolders.reverse", this.subFolders.reverse());

    })
  }

  removeFile(event) {
    console.log("EVENT OF FILE REMOVE", event);
    // this.filesToDisplay.splice(event.fileId, 1)
    // this.fileList.splice(event.fileId, 1)
    // console.log("THIS IS THE FILE LIST AFTER REMOVED", this.filesToDisplay, this.fileList);

    this.cd.detectChanges()
  }

  multiSelect() {
    this.displayCheckBoxes = true;
  }

  multiDeselect() {
    this.displayCheckBoxes = false;
  }

  selectedFolders(event) {
    if (event.event.checked == true) {
      this.selectedFoldersArray.push(event.data._id)
    }
    else {
      var temp = _.findIndex(this.selectedFoldersArray, function (o) {
        console.log("o", o, "data._id", event.data._id)
        return o == event.data._id
      })
      console.log("temp", temp)
      if (temp > -1) {
        this.selectedFoldersArray.splice(temp, 1)
      }
    }
    console.log("this.selectedFoldersArray=====>>>>>", this.selectedFoldersArray)
  }
  selectedFiles(event) {
    if (event.event.checked == true) {
      this.selectedFilesArray.push(event.data._id)
    }
    else {
      var temp = _.findIndex(this.selectedFilesArray, function (o) {
        console.log("o", o, "data._id", event.data._id)
        return o == event.data._id
      })
      console.log("temp", temp)
      if (temp > -1) {
        this.selectedFilesArray.splice(temp, 1)
      }
    }
    console.log("this.selectedFoldersArray=====>>>>>", this.selectedFilesArray)
  }

  openShareDialog(action) {
    console.log('action', action)
    let obj = {
      files: this.selectedFilesArray,
      folder: this.selectedFoldersArray,
    }
    this.openDialog(ShareFileModalComponent, { action: action }).subscribe(res => {
      if (!res) return
      obj['clients'] = res.clients;
      obj['instructors'] = res.instructors
      if (action == 'share') {

      }
      else {

      }
      console.log('res', res)
      this.displayCheckBoxes = false
    })
  }
  onHoverFolder(i) {
    // console.log("bread on hover i", i)
    this.newFolderIndex = i
    let folderName
    // console.log("this.subFolders.length", this.subFolders.length, i)
    if (i < this.subFolders.length) {
      folderName = this.subFolders[i].title
      this.destFolderName = folderName
      // this.folderName.emit(folderName)
      // console.log('sorting event on HOVER', folderName)
    }
    // console.log(" this.mainFolderId ", this.mainFolderId)
    this._folderService.setCurrentSelectedFolderIndex(this.mainFolderId);
    this.cd.detectChanges();
  }

  yash(folder) {
    // console.log("shukla",folder)
    // alert(" Shukla ")
  }

  setBreadCrumbPlaceHolder(event) {
    this.destFolderName = event
    this.cd.detectChanges();
  }

  // passId(_id) {
  //   this.mainFolderId = _id
  // }

  onFolderLeave(i) {
    // console.log("on FOLDER leave", i)
    this.newFolderIndex = -1
    this.destFolderName = ''
  }

  nonAdminRead() {
    let docs = this.selectedFoldersArray.concat(this.selectedFilesArray)
    console.log("docs", docs)
    this._folderService.markAsRead(docs).subscribe(res => {
      if (this.refModule == 'labourjob') {
        this.allFolders = this.allFolders.filter((x) => {
          if (docs.includes(x._id)) {
            x.status.isRead = true
          }
          return x
        })
        // } else {
        this.filesToDisplay = this.filesToDisplay.filter((x) => {
          if (docs.includes(x._id)) {
            x.status.isRead = true
            return x
          } else return x
        })

        // this.getSharedDocumentsofLabour()
      }
      else this.getSharedFolders()
      console.log('marked as read', res)
      this.displayCheckBoxes = false;
      this.openSnackBar('Files marked as read', 'OK')
    })
  }

  dragMoved(event) {
    console.log('Drag Moved Calling:', event);
  }

  updateCurrentFolder(event) {
    // this.getFolderFiles();
    this.subFolders.splice(_.findIndex(this.subFolders, function (o) { return o._id == event.folderId; }), 1);
    this.subFoldersCopy.splice(_.findIndex(this.subFoldersCopy, function (o) { return o._id == event.folderId; }), 1);
    console.table("bread crumb ====>>", this.breadCrumbArray);
    // this.openFileDetails(this.subFolders[0], 'folder')
    if (this.filesToDisplay && this.filesToDisplay.length) {
      console.log("call this first if");

      this.selectedFileIndex = true
      this.openFileDetails(this.filesToDisplay[0], 'file', 'test13')
    } else if (this.subFolders && this.subFolders.length) {
      console.log("call this else if part=============");
      this.selectedIndex = true
      this.openFileDetails(this.subFolders[0], 'folder', 'test14')
    } else {

      // this.mydsidenav.close();

      this.closeFilesSideNav.emit("close")
    }
  }
  updateDisplayFiles(event) {
    this.filesToDisplay.splice(_.findIndex(this.filesToDisplay, function (o) { return o._id == event.fileId; }), 1);
    console.log("total display file list", this.filesToDisplay);
    console.log("displaay total folder details", this.subFolders);
    if (this.filesToDisplay && this.filesToDisplay.length) {

      this.selectedFileIndex = true
      this.openFileDetails(this.filesToDisplay[0], 'file', 'test15')
    } else if (this.subFolders && this.subFolders.length) {
      this.selectedIndex = true
      this.openFileDetails(this.subFolders[0], 'folder', 'test16')
    } else {

      // this.mydsidenav.close();

      this.closeFilesSideNav.emit("close")
    }

  }
  breadCrumbRestrictionMessage(event) {
    console.log("event when its not aloud", event);

    // this.openSnackBar(event, 'OK')
  }


  markAsReadFile() {
    let obj = {
      folderId: this.folderId,
      userId: this.userId,
      fileId: this.fileId
    }


    this.activatedRoute.queryParams.subscribe((queryParams) => {
      console.log("this is the query params", queryParams);
      this.flage = queryParams._type

      obj['type'] = queryParams._type
      obj['userType'] = queryParams.userType
      this._folderService.autoReadDocument(obj).subscribe((response) => {
        console.log("response of mark as read", response);
        var link = document.createElement("a");
        link.download = 'name';
        link.href = response.downloadData.path;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        // delete link;


        this.subFolders = response.folder
        if (this.subFolders && this.subFolders.length > 0) {
          this.openFileDetails(this.subFolders[0], 'folder', 'test17')
          this.activeFile = false
        }
        this.router.navigate(['/mydocuments'])
      }, err => {
        console.log("error ", err);

      })
      console.log("this is call for mark as read", this.flage, obj);
    })


  }


  markAsReadFolder(userType) {

    return new Promise((resolve, reject) => {
      let obj = {
        folderId: this.folderId,
        userId: this.userId,
        type: false,
        userType: userType
      }
      this._folderService.autoReadDocument(obj).subscribe((response) => {
        console.log("response of mark as read", response);
        resolve({ msg: 'Folder auto read done' })
      }, err => {
        console.log("error while mark folder", err);

      })
    })
  }

}